<template>
	<article>
		<file-drop
			:item="item"
			:is-updating="isUpdating"
			class="u__margin-top-30 max-width u__padding-20"
			@update-file="updateFile"
		/>
		<form class="col" autocomplete="off">
			<p class="podpis">Filtr:</p>
			<select v-model="filter">
				<option
					v-for="option in $store.getters['settings/filters']"
					:key="option.id"
					:value="option.name"
					>{{ option.name }}</option
				>
			</select>
			<p class="podpis">Link:</p>
			<input v-model="link" type="text" placeholder="Link" />
			<p class="podpis">Tytuł:</p>
			<input v-model="upText" type="text" placeholder="Tytuł" />
			<p class="podpis">Reżyser:</p>
			<input v-model="text1" type="text" placeholder="Director" />
			<p class="podpis">Producent:</p>
			<input v-model="text2" type="text" placeholder="Producer" />
			<button
				class="button__save contact__button u__margin-top-30"
				:disabled="isUpdating"
				@click.prevent="saveEntry"
			>
				<span v-if="!isUpdating">{{ $t('buttons.save') }}</span>
				<span v-else class="loader loader-small"></span>
			</button>
			<button v-if="id" class="button__delete" @click.prevent="deleteEntry">
				USUŃ
			</button>
		</form>
		<router-link to="/edit-movies" class="back">WSTECZ</router-link>
	</article>
</template>
<script>
import FileDrop from '@/components/FileDrop'

export default {
	components: {
		FileDrop
	},
	data: ({ $route, $store }) => ({
		slug: $route.params.movie,
		labels: {
			text: 'Jesteś pewien, że chcesz skasować ten wpis?',
			success: 'wpis usunięty'
		},
		filter: 'commercial',
		index: null,
		link: '',
		order: $store.getters['image/data'].length,
		upText: '',
		text1: '',
		text2: '',
		id: null,
		item: null,
		projectId: '',
		isUpdating: false
	}),
	computed: {
		isDownText: ({ text2 }) => text2.length > 0
	},
	created() {
		const index = this.$store.getters['image/data'].findIndex(
			(item) => item.id === +this.slug
		)
		if (index > -1) {
			this.index = index
			this.filter = this.$store.getters['image/data'][this.index].filter
			this.link = this.$store.getters['image/data'][this.index].link
			this.order = this.$store.getters['image/data'][this.index].order
			this.upText = this.$store.getters['image/data'][this.index].upText
			this.text1 = this.$store.getters['image/data'][this.index].text1
			this.text2 = this.$store.getters['image/data'][this.index].text2
			this.id = this.$store.getters['image/data'][this.index].id
			this.item = {
				file: { name: this.$store.getters['image/data'][this.index].name },
				preview: this.$getImgUrl(
					this.$store.getters['image/data'][this.index].name
				),
				uploaded: true
			}
			// map image
		} else if (this.slug !== 'add') {
			this.$router.replace('/404')
		}
	},
	methods: {
		updateFile(file) {
			this.item = file
		},
		deleteEntry() {
			this.$alertConfirm({
				labels: this.labels,
				action: {
					name: 'image/remove',
					payload: this.id,
					async: true,
					redirect: '/edit-movies'
				}
			})
		},
		async saveEntry() {
			if (!this.item) {
				this.$alertBox({
					labels: {
						text: 'dodaj zdjęcie'
					},
					type: 'error'
				})
			} else {
				this.isUpdating = true
				const formData = new FormData()
				if (!this.item.uploaded) {
					formData.append('image', this.item.file)
				} else {
					formData.append('image', null)
				}
				formData.append('filter', this.filter)
				formData.append('isDownText', this.isDownText)
				formData.append('link', this.link)
				formData.append('order', this.order)
				formData.append('projectId', this.projectId)
				formData.append('text1', this.text1)
				formData.append('text2', this.text2)
				formData.append('upText', this.upText)
				if (this.id) {
					formData.append('id', this.id)
					await this.$store.dispatch('image/update', { id: this.id, formData })
				} else {
					await this.$store.dispatch('image/create', formData)
				}
				this.$alertBox({
					labels: {
						text: this.$t('alerts.saved_changes')
					},
					type: 'success',
					redirect: '/edit-movies'
				})
				this.isUpdating = false
			}
		}
	}
}
</script>
